import * as React from "react";
import { QuotaStatusV3Props, QuotaStatusV3 } from "../../../parts/quota-status/v3";
import styled from "styled-components";
import { QuotaStatus } from "../../../parts/quota-status";
import { isOver3Version } from "../../../../../../shared/version";

const RedDiv = styled.div`
	color: red;
`;

export type QuotaPageProps = QuotaStatusV3Props & { version?: string };
export const QuotaPage = React.memo((props: QuotaPageProps) => {
	const { version, isCMI, quotas, isDemandForecastNeeded } = props;
	return (
		<div className="m-3 clearfix">
			<div className="h3">■回収状況</div>
			{props.isCMI && (
				<RedDiv>
					回収数はデータクリーニング前の数値です。集計時の有効回答数は減少する場合があります。（予定数に対してショートしているセルの回収数は減少しません。）
				</RedDiv>
			)}
			{isOver3Version(version) ? (
				<QuotaStatusV3 isCMI={isCMI} quotas={quotas} isDemandForecastNeeded={isDemandForecastNeeded} />
			) : (
				<QuotaStatus isCMI={isCMI} quotas={quotas} />
			)}
		</div>
	);
});
